var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-up-button",class:{
        'ui-up-button--index': _vm.$route.name === 'index',
        'ui-up-button--visible': _vm.isVisible && this.$store.state.filterVisible
    },on:{"click":_vm.toTop}},[_c('up-icon',{staticClass:"ui-up-button__icon"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }